module.exports = __webpack_public_path__ + "static/media/galerija_2016 (3).a3616760.jpg";